export const formatTaxRate = (input: number) =>
  (Math.round(input * 10000) / 100).toFixed(2);

export function formatCurrency(
  amount: number,
  currency = 'USD',
  options: Intl.NumberFormatOptions = {}
): string {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    ...options,
  });

  return formatter.format(amount);
}

export function formatPercentage(amount: number): string {
  return `${(Math.round(amount * 10000) / 100).toFixed(2)}%`;
}

// reference: optionCost.service.ts

export function formatMonthlyCurrency(
  totalPrice: number,
  costings: {
    interestRate: number;
    termMonths: number;
  },
  currency = 'USD'
): string {
  if (costings.termMonths === 0) {
    return formatCurrency(totalPrice, currency);
  }

  if (costings.interestRate === 0) {
    return formatCurrency(totalPrice / costings.termMonths, currency);
  }

  const monthlyRate = costings.interestRate / 12;
  const { termMonths } = costings;

  const numerator =
    totalPrice * monthlyRate * Math.pow(1 + monthlyRate, termMonths);
  const denominator = Math.pow(1 + monthlyRate, termMonths) - 1;
  const monthlyPayment = numerator && denominator ? numerator / denominator : 0;

  return formatCurrency(monthlyPayment, currency);
}

export const getDisplayedPrice = (
  price: number,
  displayMode: 'TOTAL_COST' | 'FINANCING_PAYMENT' | 'FINANCING_AND_TOTAL_COST',
  costings?: { interestRate: number; termMonths: number },
  currency = 'USD'
) => {
  const totalCost = formatCurrency(price || 0, currency);
  if (displayMode === 'TOTAL_COST') {
    return totalCost;
  } else if (
    displayMode === 'FINANCING_PAYMENT' &&
    typeof costings?.interestRate === 'number' &&
    typeof costings?.termMonths === 'number'
  ) {
    return `As low as ${formatMonthlyCurrency(
      price || 0,
      {
        interestRate: costings.interestRate,
        termMonths: costings.termMonths,
      },
      currency
    )}/month`;
  } else if (displayMode === 'FINANCING_AND_TOTAL_COST') {
    if (
      typeof costings?.interestRate === 'number' &&
      typeof costings?.termMonths === 'number'
    ) {
      return `${formatCurrency(
        price || 0,
        currency
      )} or ${formatMonthlyCurrency(
        price || 0,
        {
          interestRate: costings.interestRate,
          termMonths: costings.termMonths,
        },
        currency
      )}/month`;
    }

    return totalCost;
  }

  return totalCost;
};
